// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/views/admin.navigation.show.scss
// module id = 14
// module chunks = 0